<template>
  <div class="px-4 py-3">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-xl font-semibold text-gray-800">Mes Devis</h1>
      <!-- Actions -->

    </div>

    <!-- Cards -->
    <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <!-- Total devis -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Total de Devis</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-file-alt text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ totalDevis }}</div>
          <div class="text-xs text-gray-500">total</div>
        </div>
      </div>

      <!-- En attente -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">En Attente</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-hourglass-half text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ devisEnAttente }}</div>
          <div class="text-xs text-gray-500">Devis</div>
        </div>
      </div>

      <!-- Signé -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Signé</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-check text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ devisSignes }}</div>
          <div class="text-xs text-gray-500">Acceptés</div>
        </div>
      </div>

      <!-- Expirés -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Expiré</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-times text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ devisExpires }}</div>
        </div>
      </div>
    </div>

    <!-- Tableau des devis -->
    <div class="mt-8">
      <div class="overflow-x-auto bg-white shadow-sm rounded-2xl border border-gray-100">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Numéro</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Montant</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Crée le</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valide jusqu'au</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
           <tr v-for="item in tableauDevisPaginated" :key="item.id">

              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.numero }}</td>
<td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
  <span
    :class="[
      'transition duration-300',
      item.statut === 'Envoyé'
        ? 'blur-sm select-none text-gray-400'
        : 'blur-0'
    ]"
  >
    {{ item.montant }} €
  </span>
  <span v-if="item.statut === 'Envoyé'" class="ml-2 text-gray-400">
    🔒
  </span>
</td>



              <td class="px-6 py-4 whitespace-nowrap text-sm">
                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="statutClass(item)">
                  {{ item.statut }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.date }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.Fin_de_validité }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex gap-2">
                <button
                  @click="voirDevis(item)"
                  class="p-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition"
                  title="Voir"
                >
                  <i class="fas fa-eye"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
        <!-- Pagination -->
    <div class="flex gap-6 justify-end items-center mt-4">
      <button
        @click="prevPage"
        :disabled="currentPage === 1"
        class="flex items-center gap-1 px-3 py-3 border rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
    <!-- Chevron gauche -->
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
      </button>

      <button
        v-for="page in totalPages"
        :key="page"
        @click="goToPage(page)"
        :class="['', page === currentPage ? ' text-blue-600' : ' ']"
      >
        {{ page }}
      </button>

      <button
        @click="nextPage"
        :disabled="currentPage === totalPages"
       class="flex items-center gap-1 px-3 py-3 border rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <!-- Chevron droit -->
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
    </svg>
      </button>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()

// Stats

const devisEnAttente = ref(0)
const devisSignes = ref(0)
const devisExpires = ref(0)
const totalDevis = ref(0);

// Liste complète des devis
const tableauDevis = ref([])

// Pagination
const currentPage = ref(1)
const pageSize = ref(5) // nombre de devis par page
const totalPages = computed(() => Math.ceil(tableauDevis.value.length / pageSize.value))

// Devis pour la page actuelle
const tableauDevisPaginated = computed(() => {
  // On inverse le tableau pour que le dernier ajouté soit le premier
  const reversed = [...tableauDevis.value].reverse()

  // Pagination
  const start = (currentPage.value - 1) * pageSize.value
  const end = start + pageSize.value
  return reversed.slice(start, end)
})


// 🔹 Méthodes de pagination
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (page) => { if (page >= 1 && page <= totalPages.value) currentPage.value = page }

// 🔹 Récupération des devis depuis l'API
const fetchDevis = async () => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get('https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/devis', {
      headers: { Authorization: `Bearer ${token}` }
    });

    // On remplit le tableau de devis
    tableauDevis.value = res.data.devis.map(d => ({
      id: d._id,
      numero: d.devisNumero,
      montant: d.totalTTC || d.produits.reduce((total, p) => total + (p.prix || 0), 0),
      statut: d.statut || 'Ouvert',
      dateDevis: d.dateDevis, // ✅ on garde la date ISO pour le tri
      date: new Date(d.dateDevis).toLocaleDateString(),
      Fin_de_validité: new Date(d.dateFinValidite).toLocaleDateString(),
    }));

    // 🔹 Nombre total de devis
    totalDevis.value = tableauDevis.value.length;

    // Optionnel : stats par statut
    devisEnAttente.value = tableauDevis.value.filter(d => d.statut === 'Ouvert' || d.statut === 'Envoyé').length;
    devisSignes.value = tableauDevis.value.filter(d => d.statut === 'Terminé').length;
    devisExpires.value = tableauDevis.value.filter(d => d.statut === 'Expiré').length;

  } catch (err) {
    console.error('Erreur récupération devis:', err);
  }
};


// 🔹 Devis triés du plus récent au plus ancien

// Appel au montage
onMounted(fetchDevis)

// 🔹 Redirection vers la page billing du devis
const voirDevis = (item) => router.push(`/billing/${item.id}`)

// 🔹 Classe CSS selon statut
const statutClass = (item) => {
  switch (item.statut) {
    case 'Envoyé': return 'bg-blue-100 text-blue-800'
    case 'Ouvert': return 'bg-yellow-100 text-yellow-800'
    case 'Signé': return 'bg-green-100 text-green-800'
    case 'Expiré': return 'bg-red-100 text-red-800'
    default: return 'bg-gray-100 text-gray-800'
  }
}
</script>



